var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 22.4V16.85H26.15C26.55 16.85 26.8917 16.7083 27.175 16.425C27.4583 16.1417 27.6 15.7833 27.6 15.35C27.6 14.9167 27.4583 14.5583 27.175 14.275C26.8917 13.9917 26.5333 13.85 26.1 13.85H21.25C20.45 13.85 19.75 14.15 19.15 14.75C18.55 15.35 18.25 16.05 18.25 16.85V31.15C18.25 31.95 18.55 32.65 19.15 33.25C19.75 33.85 20.45 34.15 21.25 34.15H26.75C27.55 34.15 28.25 33.85 28.85 33.25C29.45 32.65 29.75 31.95 29.75 31.15V25.4C29.75 24.6 29.45 23.9 28.85 23.3C28.25 22.7 27.55 22.4 26.75 22.4H21.25ZM21.25 25.4H26.75V31.15H21.25V25.4ZM9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.23333 6.3 7.54167 6.9 6.925C7.5 6.30833 8.2 6 9 6H39C39.7667 6 40.4583 6.30833 41.075 6.925C41.6917 7.54167 42 8.23333 42 9V39C42 39.8 41.6917 40.5 41.075 41.1C40.4583 41.7 39.7667 42 39 42H9ZM9 39H39V9H9V39ZM9 9V39V9Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.9eca5d351f9ffe887e1018f7fce6b06c.svg";
export { ForwardRef as ReactComponent };